import React from 'react';
import { usePopupStore } from '../store/usePopupStore';
import { Share2, RotateCcw, Home } from 'lucide-react';
import html2canvas from 'html2canvas';

export const SharedGamePopup: React.FC = () => {
  const { isOpen, type, title, score, message, onRestart, onHome, closePopup } = usePopupStore();

  if (!isOpen) return null;

  const handleShare = async () => {
    try {
      // Hide the popup temporarily so it doesn't appear in the screenshot
      const popupEl = document.getElementById('shared-game-popup-overlay');
      if (popupEl) popupEl.style.visibility = 'hidden';

      // Capture the main app container or document body
      const canvas = await html2canvas(document.body, {
        backgroundColor: null,
        useCORS: true,
      });

      if (popupEl) popupEl.style.visibility = 'visible';

      canvas.toBlob(async (blob) => {
        if (!blob) {
          alert('Failed to generate screenshot.');
          return;
        }

        const file = new File([blob], 'eternally_score.png', { type: 'image/png' });
        const shareData = {
          title: 'Eternally Games',
          text: `I just scored ${score} in ${title}! Can you beat me? Play now at https://eternally.games`,
          files: [file]
        };

        if (navigator.canShare && navigator.canShare(shareData)) {
          await navigator.share(shareData);
        } else {
          alert('Native sharing is not supported on your device/browser.');
        }
      }, 'image/png');
    } catch (err) {
      console.error('Error sharing:', err);
      // Ensure popup is visible again on error
      const popupEl = document.getElementById('shared-game-popup-overlay');
      if (popupEl) popupEl.style.visibility = 'visible';
    }
  };

  const isSuccess = type === 'success';

  return (
    <div id="shared-game-popup-overlay" className="gtheme-overlay" style={{ zIndex: 9999 }}>
      <div className="gtheme-panel" style={{ padding: '3rem 2rem 2rem', maxWidth: '360px' }}>
        
        {/* Ribbon Title */}
        <div className="gtheme-ribbon" style={{ 
          background: isSuccess ? '#10b981' : '#ef4444', 
          boxShadow: `0 6px 0 ${isSuccess ? '#047857' : '#991b1b'}, inset 0 -4px 0 rgba(0,0,0,0.1)` 
        }}>
          <h2>{title}</h2>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', textAlign: 'center' }}>
          <p className="gtheme-panel-text">{message}</p>
          
          {score !== null && (
            <div className="gtheme-hud-pill" style={{ flexDirection: 'column', padding: '1rem', border: '4px solid #d4c5a5' }}>
              <span className="gtheme-hud-label">SCORE</span>
              <span className="gtheme-hud-value" style={{ fontSize: '2.5rem', textShadow: '2px 2px 0 #1e3a8a' }}>{score}</span>
            </div>
          )}
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <button className="gtheme-btn gtheme-btn-primary" onClick={handleShare}>
              <Share2 size={24} />
              Share
            </button>

            <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem', justifyContent: 'center' }}>
              <button className="gtheme-btn gtheme-btn-round" onClick={() => { closePopup(); onRestart(); }}>
                <RotateCcw size={28} />
              </button>
              <button className="gtheme-btn gtheme-btn-round gtheme-btn-danger" onClick={() => { closePopup(); onHome(); }}>
                <Home size={28} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
